<template>
  <div v-if="!editMode">
    <CustomerListItem :item="editItem.Customer" :singleline="!!editItem.CustomerDeliveryAddressId"
      @click="openCustomer()">
    </CustomerListItem>
    <AddressListItem v-if="editItem.CustomerDeliveryAddress" :key="addressResetKey"
      :item="editItem.CustomerDeliveryAddress">
    </AddressListItem>
  </div>

  <v-container v-else class="pt-0">
    <CustomerSelect v-model="editItem.CustomerId" :externaledit="isNew || editMode" @FocusState="handleFocus">
    </CustomerSelect>
    <CustomerDeliveryAddressSelect v-model="editItem.CustomerDeliveryAddressId" :key="addressResetKey"
      :customer-id="editItem.CustomerId" :existing-address="editItem.CustomerDeliveryAddress" hideCustomerDefaultAddress
      :externaledit="isNew || editMode" clearable class="mt-2" @FocusState="handleFocus">
    </CustomerDeliveryAddressSelect>
  </v-container>
</template>


<script>
import Vue from "vue";
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from '@/components/Inputs/EntityDropdowns/CustomerSelect2.vue';
import CustomerDeliveryAddressSelect from '@/components/Inputs/EntityDropdowns/CustomerDeliveryAddressSelect.vue';
import CustomerListItem from "@/components/ListItems/CustomerListItem.vue";
import AddressListItem from "@/components/ListItems/AddressListItem.vue";

export default {
  name: "MachineCustomerEditContent",
  props: {
    editItem: Object,
    editMode: Boolean,
    handleFocus: Function,
  },
  components: {
    CustomerSelect,
    CustomerDeliveryAddressSelect,
    CustomerListItem,
    AddressListItem,
  },
  mixins: [clientAPI],

  data() {
    return {
      addressResetKey: 1,
    };
  },

  methods: {
    openCustomer() {
      this.$router.push({ name: 'ViewCustomer', params: { customerId: this.editItem.CustomerId } })
    },
    formatAddress(addr) {
      if (!addr) return "";
      const parts = [addr.Name, addr.Street, addr.Zip, addr.City, addr.Country].filter((p) => p != null && p !== "");
      return parts.join(", ");
    },
  },

  computed: {
    isNew() {
      return this.editItem?.Id == null;
    },
  },

  watch: {
    "editItem.CustomerId"(newVal, oldVal) {
      if (oldVal !== undefined && newVal !== oldVal) {
        Vue.set(this.editItem, "CustomerDeliveryAddressId", null);
        Vue.set(this.editItem, "CustomerDeliveryAddress", null);
        this.addressResetKey++;
      }
    },
  },
};
</script>


<style lang='scss'></style>